"use strict";
module.exports = function(config, get){
	return {
		list: handle_list,
		make_download_url: make_download_url
	};

	function handle_list(query, page){
		return get("/v2/org/reports/list", {
			query,
			page
		});
	}

	function make_download_url(key){
		return (`${config.host}/v2/org/reports/get?key=${key}&token=${config.token}`);
	}
};